import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../api.service';
import { CategoryLan } from '../shared/models/CategoryLan';
import { OptionsAssistDocument } from '../shared/models/OptionsAssistDocument';

@Component({
  selector: 'app-tovpil-options-assists',
  templateUrl: './tovpil-options-assists.component.html',
  providers: [MessageService, ConfirmationService],
  styleUrls: ['./tovpil-options-assists.component.scss']
})
export class TovpilOptionsAssistsComponent implements OnInit {
  optionAssist?: OptionsAssistDocument;
  optionId?: string;
  textUser?: string;
  userId?: string;
  windowDialog?: boolean;
  userCanEdit?: boolean;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
     
    private router: Router


  ) { }

  ngOnInit(): void {
    this.route.queryParams
    .subscribe(
      params => {
        this.optionId = params.optionId;
        this.userId=params.userId;            
      });
      this.checkUserCanEdit();
      this.apiService.getOptionsAssistByKey({"optionId":this.optionId})
      .then(
        data => {        
             this.optionAssist = data;
             this.windowDialog=true;
        }
      )
  }

  createUpdateAssist(){
    this.apiService.createUpdateOptionsAssist({
      "key":{
        "optionId":this.optionId
      },
      "objective":this.optionAssist.objective,
      "characteristics":this.optionAssist.characteristics,
      "observations":this.optionAssist.observations,
      "results":this.optionAssist.results})
    .then(
        data => {
          this.messageService.add({severity:'success', summary: 'Ayuda guardada correctamente', detail: 'Se guardo y/o actualizo información correctamente', life: 3000});
        }
    )
  }

  hideDialog() {   
    window.close();
  }

  checkUserCanEdit(){
    this.userCanEdit=false;
    let cat: CategoryLan[]; 
    this.apiService.getCategoryLang({
      "fieldId": "usersDocum"
    }).then(
      data => {
        cat = data;
        cat.forEach((element) => {
          if(element.descrip.trim()==this.userId){
            this.userCanEdit=true;
            this.textUser='(ESTE USUARIO PUEDE EDITAR AYUDAS)';
          }
        });      
      })
  }
  goToRules(){
    this.router.navigate(['commons/rulesOption'],{ queryParams: { opt: this.optionId,userId:this.userId } });
  }

}
